import React from "react";

export default function JPGIcon() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="19"
      height="21"
      viewBox="0 0 19 21"
      fill="none"
    >
      <path
        d="M15.0831 0H7.32433H6.72376L6.29896 0.38202L0.424799 5.66434L0 6.04636V6.58678V17.477C0 19.4195 1.75716 21 3.91755 21H15.0831C17.2428 21 19 19.4195 19 17.477V3.52308C19 1.58025 17.2428 0 15.0831 0ZM17.5498 17.477C17.5498 18.7024 16.4454 19.6955 15.0831 19.6955H3.91755C2.55522 19.6955 1.45086 18.7024 1.45086 17.477V6.58674H5.26907C6.404 6.58674 7.32433 5.75913 7.32433 4.73817V1.30446H15.0831C16.4454 1.30446 17.5498 2.29761 17.5498 3.52308V17.477Z"
        fill="#90CAF9"
      />
      <path
        d="M9.76477 15.5444C8.95772 15.724 8.3247 13.9625 7.23612 13.8121C6.14754 13.6632 4.37305 17.5714 4.37305 17.5714H14.7982C14.7982 17.5714 14.3085 11.0287 12.3446 11.0824C10.379 11.1361 10.5701 15.3649 9.76477 15.5444Z"
        fill="#1565C0"
      />
      <path
        d="M6.9898 11.762C7.81151 11.762 8.47764 11.1629 8.47764 10.4239C8.47764 9.68498 7.81151 9.08594 6.9898 9.08594C6.16808 9.08594 5.50195 9.68498 5.50195 10.4239C5.50195 11.1629 6.16808 11.762 6.9898 11.762Z"
        fill="#1976D2"
      />
    </svg>
  );
}
